(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockZahlungsweise', {
            require: {
                form: '^form'
            },
            bindings: {
                disabled: '<abzDisabled',
                moeglicheZahlweisen: '<abzMoeglicheZahlweise',
                changeZahlweise: '&?abzChangeZahlweise',
                options: '<abzOptions'
            },
            templateUrl: 'bloecke/zahlungsweise/blockZahlungsweise.html',
            controller: BlockZahlungsweiseController,
            controllerAs: 'zahlungsweiseVm'
        });

    BlockZahlungsweiseController.$inject = [
        'lodash',
        'AngebotModel',
        'AppConfig',
        'FormatUtilsService'
    ];
    function BlockZahlungsweiseController(_, AngebotModel, AppConfig, FormatUtilsService) {
        var vm = this,
            zahlweisen = AppConfig.ANGEBOT.zahlweisen;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.onChange = onChange;

        function activate() {
            vm.options = vm.options || {};
            vm.angebotModel = AngebotModel.get();

            vm.options.orderBy = vm.options.orderBy || 'wert';
            vm.cssClass = vm.options.cssClass || '';
        }

        function onInit() {
            activate();
        }

        function onChanges() {
            vm.zahlweisenNurLastschriftText = FormatUtilsService.joinArrayByCondition(['vierteljährliche', 'monatliche'], [!!_.find(vm.moeglicheZahlweisen, ['wert', zahlweisen.VIERTELJAEHRLICH.wert]), !!_.find(vm.moeglicheZahlweisen, ['wert', zahlweisen.MONATLICH.wert])], ' und ');
        }

        function onChange(value) {
            vm.changeZahlweise();
        }
    }
})();
